var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.live_stream && _vm.live_stream[0].status !== 0 &&
    ((_vm.fromPage === 'team' && _vm.live_stream[0].status >= 2) ||
      (_vm.fromPage === 'campaign' && _vm.live_stream[0].status <= 2))
  )?_c('div',{staticClass:"d-flex justify-center my-10 rounded-lg black ch-shadow",staticStyle:{"height":"500px"},attrs:{"id":"videoSection"}},[_c('iframe',{attrs:{"width":"100%","height":"500","title":"Dvir Media Player","src":("" + (_vm.live_stream[0].path)),"frameborder":"0","allowfullscreen":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }